"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConversationMessagesOutputDtoSchema = exports.agentChatMessageMetadataDtoSchema = exports.agentChatMessageTokenUsageMetadataDtoSchema = exports.agentChatMessageModelMetadataDtoSchema = exports.getConversationMessagesInputDtoSchema = void 0;
const zod_1 = require("zod");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
exports.getConversationMessagesInputDtoSchema = zod_1.z.object({
    conversationId: conversation_summary_dto_js_1.agentChatConversationIdSchema,
});
exports.agentChatMessageModelMetadataDtoSchema = zod_1.z.object({
    provider: zod_1.z.enum(['openai', 'anthropic']),
    model: zod_1.z.string().min(1),
});
exports.agentChatMessageTokenUsageMetadataDtoSchema = zod_1.z.object({
    inputTokens: zod_1.z.number().int().nonnegative(),
    outputTokens: zod_1.z.number().int().nonnegative(),
    totalTokens: zod_1.z.number().int().nonnegative(),
    cachedInputTokens: zod_1.z.number().int().nonnegative(),
    cacheCreationTokens: zod_1.z.number().int().nonnegative(),
    reasoningTokens: zod_1.z.number().int().nonnegative(),
});
exports.agentChatMessageMetadataDtoSchema = zod_1.z.object({
    model: exports.agentChatMessageModelMetadataDtoSchema.optional(),
    usage: exports.agentChatMessageTokenUsageMetadataDtoSchema.optional(),
});
exports.getConversationMessagesOutputDtoSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.string(),
    role: zod_1.z.enum(['user', 'assistant']),
    parts: zod_1.z.array(zod_1.z.unknown()),
    metadata: exports.agentChatMessageMetadataDtoSchema.optional(),
}));
//# sourceMappingURL=get-conversation-messages.dto.js.map